/*
    <render></render> is limited by what strings can be passed as parameters into inner components. This can be used to pack and unpack strings that are in a valid JSON format into parameters.
    Takes a stringified JSON and converts it into a form that Vue renderer can process. Must be unpacked at the other end.
*/
//Do not use backslash with shorthand version or you will get an error.
const specials = {
    quote: {
        symbol: "\"",
        replacement: "_$quot;",
        _replacement: "_\\$quot;"
    },
    squote: {
        symbol: "'",
        replacement: "_$squot;",
        _replacement: "_\\$squot;"
    },
    lessThan: {
        symbol: "<",
        replacement: "_$lst;",
        _replacement: "_\\$lst;"
    },
    greaterThan: {
        symbol: ">",
        replacement: "_$gt;",
        _replacement: "_\\$gt;"
    }
};
function fullPack(s) {
    return s
        .replace(new RegExp(specials.squote.symbol, "g"), specials.squote.replacement)
        .replace(new RegExp(specials.quote.symbol, "g"), specials.quote.replacement)
        .replace(new RegExp(specials.lessThan.symbol, "g"), specials.lessThan.replacement)
        .replace(new RegExp(specials.greaterThan.symbol, "g"), specials.greaterThan.replacement);
}
function fullUnpack(s) {
    return s
        .replace(new RegExp(specials.squote._replacement, "g"), specials.squote.symbol)
        .replace(new RegExp(specials.quote._replacement, "g"), specials.quote.symbol)
        .replace(new RegExp(specials.lessThan._replacement, "g"), specials.lessThan.symbol)
        .replace(new RegExp(specials.greaterThan._replacement, "g"), specials.greaterThan.symbol);
}
const jsonTools = {
    install(app, options = {}) {
        app.provide("$json", {
            pack: function (s) {
                return fullPack(s);
            },
            unpack: function (s) {
                return fullUnpack(s);
            },
            packed: function (s) {
                if (!s)
                    return false;
                return s.includes(specials.quote.replacement) || s.includes(specials.squote.replacement) || s.includes(specials.lessThan.replacement) || s.includes(specials.greaterThan.replacement);
            },
            isJSON: function (s) {
                //Should help lower the cost than always using JSON.parse() as a check
                if (typeof s !== "string")
                    return false;
                try {
                    JSON.parse(s);
                    return true;
                }
                catch (err) {
                    return false;
                }
            },
        });
    }
};
export default jsonTools;
